// https://stackoverflow.com/questions/46573804/firestore-query-documents-startswith-a-string
export const startsWithEndCode = (str: string): string => {
    let length = str.length;
    let strFrontCode = str.slice(0, length - 1);
    let strEndCode = str.slice(length - 1, str.length);

    return strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1)
}
